import { FC } from "react";
import { AxiosError } from "axios";
import ApiErrorHandler from "../../interfaces/ApiErrorHanadler";
import ApiResponseHandler from "../../interfaces/ApiResponseHandler";
import ErrorPage from "./ErrorPage";
import NoAccessPage from "./NoAccessPage";
import MaintenancePage from "./MaintenancePage";
import NotFoundPage from "./NotFoundPage";

import {
  INTERNAL_SERVER_ERROR_DESCRIPTION,
  INTERNAL_SERVER_ERROR_TITLE,
  EXPORT_DOWNLOAD_SERVER_ERROR_TITLE,
  EXPORT_DOWNLOAD_SERVER_ERROR_MESSAGE,
  EXPORT_DOWNLOAD_SERVER_ERROR_DETAILS,
} from "@/constants";

const APIErrorHandling: FC<ApiErrorHandler> = ({ error, type }) => {
  const message = "";
  if ((error as AxiosError).isAxiosError) {
    const axiosError = error as AxiosError<ApiResponseHandler>;
    const status = axiosError.response?.status;
    if (status == 500) {
      return (
        <ErrorPage
          title={
            type && type === "exportCSV"
              ? EXPORT_DOWNLOAD_SERVER_ERROR_TITLE
              : INTERNAL_SERVER_ERROR_TITLE
          }
          message={
            type && type === "exportCSV"
              ? EXPORT_DOWNLOAD_SERVER_ERROR_MESSAGE
              : INTERNAL_SERVER_ERROR_DESCRIPTION
          }
          details={
            type && type === "exportCSV"
              ? EXPORT_DOWNLOAD_SERVER_ERROR_DETAILS
              : message
          }
        />
      );
    } else if (status == 403) {
      return <NoAccessPage />;
    } else if (status == 503) {
      <MaintenancePage />;
    } else if (status == 404) {
      return <NotFoundPage />;
    }
  } else {
    return (
      <ErrorPage
        title={INTERNAL_SERVER_ERROR_TITLE}
        message={INTERNAL_SERVER_ERROR_DESCRIPTION}
        details={message ?? undefined}
      />
    );
  }
};

export default APIErrorHandling;
